// extracted by mini-css-extract-plugin
export default {"container":"blog_container__0e1+L","header_blog":"blog_header_blog__0+0pl","custom_splide":"blog_custom_splide__iIywR"};